// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"OptOutForm_subtitle___o55t"};